export const RenderDoneSymbol = Symbol('RenderDone')
